import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import PermissionsTable from './table/PermissionsTable'
import ProfilesLoader from './_load/ProfilesLoader'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'

const EditPermissionsModal = props => {
  return (
    <ControlledModal fullScreen {...props}>
      <ModalHeader />

      <Scroll height="80vh" scroll scrollX direction="column">
        <PermissionChecker ownerOnly>
          <ProfilesLoader>
            <PermissionsTable />
          </ProfilesLoader>
        </PermissionChecker>
      </Scroll>
    </ControlledModal>
  )
}

export default EditPermissionsModal
